import { PlateThumbnailSection } from './PlateThumbnailSection';

export default PlateThumbnailSection;
